export enum AccountingPeriodStatus {
  Past = "PAST",
  Current = "CURRENT",
  Future = "FUTURE",
}

const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-\d{2}/

const parseYearMonth = (isoDate: string): { year: number; month: number } | undefined => {
  const match = ISO_DATE_PATTERN.exec(isoDate)
  if (!match) return undefined

  return { year: Number(match[1]), month: Number(match[2]) }
}

// The Accounting Period is the Invoice Date's calendar month and year as MM-YY (2026-03-10 -> "03-26").
export const formatAccountingPeriod = (invoiceDate: string | null | undefined): string | undefined => {
  const yearMonth = invoiceDate ? parseYearMonth(invoiceDate) : undefined
  if (!yearMonth) return undefined

  return `${String(yearMonth.month).padStart(2, "0")}-${String(yearMonth.year % 100).padStart(2, "0")}`
}

const ACCOUNTING_PERIOD_PATTERN = /^(\d{2})-(\d{2})$/

// Turns the MM-YY accounting period into a readable "March 2026" for places with room for the full form.
export const formatAccountingPeriodLong = (accountingPeriod: string | null | undefined): string | undefined => {
  const match = accountingPeriod ? ACCOUNTING_PERIOD_PATTERN.exec(accountingPeriod) : null
  if (!match) return undefined

  const month = Number(match[1])
  if (month < 1 || month > 12) return undefined

  return new Date(2000 + Number(match[2]), month - 1, 1).toLocaleString("en-US", { month: "long", year: "numeric" })
}

export const getAccountingPeriodStatus = (
  invoiceDate: string | null | undefined,
  today: Date = new Date()
): AccountingPeriodStatus | undefined => {
  const yearMonth = invoiceDate ? parseYearMonth(invoiceDate) : undefined
  if (!yearMonth) return undefined

  // Collapse (year, month) to a month ordinal so December -> January compares correctly.
  const invoiceOrdinal = yearMonth.year * 12 + yearMonth.month
  const currentOrdinal = today.getFullYear() * 12 + today.getMonth() + 1

  if (invoiceOrdinal < currentOrdinal) return AccountingPeriodStatus.Past
  if (invoiceOrdinal > currentOrdinal) return AccountingPeriodStatus.Future
  return AccountingPeriodStatus.Current
}
